export enum Locales {
  UKRAINIAN = 'uk',
  ENGLISH = 'en',
}

export const LOCALE = 'locale';
